import React from "react";
import UserProfile from "components/app/user/profile";

type ScreenUserProfileProps = React.PropsWithChildren<{}>;

function ScreenUserProfile(props: ScreenUserProfileProps) {
	return <UserProfile />;
}

export default ScreenUserProfile;